<template>
  <div class="timeline-stepper" v-if="isAdmin">
    <button @click="decrementStep">–</button>
    <button @click="incrementStep">+</button>
  </div>
</template>


<script>
import { mapActions, mapGetters, mapState } from 'vuex';
export default {
  name: 'Timelinestepper',
  computed: {
    ...mapGetters([
      'currentUserProfile'
    ]),
    ...mapState([
      'isAdmin'
    ])
  },
  methods: {
    ...mapActions([
      'setTimelineStep'
    ]),
    decrementStep() {
      const val = this.currentUserProfile?.timelineStep - 1
      if (val >= 0) {
        this.setTimelineStep(val)
        this.scrollToTask(val)
      }
    },
    incrementStep() {
      const newVal = this.currentUserProfile?.timelineStep + 1
      if (!this.isOnLastStep) {
        this.setTimelineStep(newVal)
        this.scrollToTask(newVal)
      }
    },
    scrollToTask(num) {
      document.getElementById(`task-${num}`)?.scrollIntoView({behavior: 'smooth'})
    }
  }
};
</script>
<style lang="scss" scoped>
.timeline-stepper {
  position: fixed;
  top: 120px;
  right: 2rem;
  z-index: 1;
  button {
    @include btn-reset;
    background: #eee;
    width: 2rem;
    height: 2rem;
    border: solid 1px #888;
    font-size: 16px;
    &:first-child {
      border-top-left-radius: 50%;
      border-bottom-left-radius: 50%;
    }
    &:last-child {
      border-left: none;
      border-top-right-radius: 50%;
      border-bottom-right-radius: 50%;
    }
  }
}
</style>